module.exports = __webpack_public_path__ + "static/media/person-3.8d036d2a.png";